import { ReactNode, useEffect, useRef, useState } from 'react'
import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface AccordionProps {
  className?: string;
  trigger: ReactNode;
  content: ReactNode;
  duration?: number;
  easing?: string;
  triggerClassName?: string;
  contentClassName?: string;
  defaultOpen?: boolean;
  arrowIcon?: boolean;
}

export default function Accordion ({
  className,
  trigger,
  content,
  duration = 300,
  easing = 'ease-out',
  triggerClassName,
  contentClassName,
  defaultOpen = false,
  arrowIcon = true,
}: AccordionProps) {
  const [ isActive, setIsActive ] = useState(defaultOpen)
  const contentRef = useRef<HTMLDivElement>(null)
  const prevActive = useRef<boolean>(defaultOpen)

  const toggle = () => {
    setIsActive((prev) => !prev)
  }

  useEffect(() => {
    const $content = contentRef.current
    if (!$content) return

    const scrollHeight = $content.scrollHeight

    if (isActive) {
      $content.animate([ { height: '0px' }, { height: `${scrollHeight}px` } ], {
        duration,
        easing,
      }).onfinish = () => {
        $content.style.height = 'auto'
      }
    }
    else if (prevActive.current) {
      $content.animate([ { height: `${scrollHeight}px` }, { height: '0px' } ], {
        duration,
        easing,
      }).onfinish = () => {
        $content.style.height = '0px'
      }
    }

    prevActive.current = isActive
  }, [ isActive, duration, easing ])

  return (
    <div className={className}>
      <div
        onClick={toggle}
        style={{ cursor: 'pointer' }}
        className={cn(triggerClassName, styles.trigger)}
      >
        {arrowIcon && (
          <ReactSVG
            className={cn(styles.trigger__icon, {
              [styles.active]: isActive,
            })}
            src="/icons/arrow.svg"
            wrapper="span"
          />
        )}

        {trigger}
      </div>

      <div
        ref={contentRef}
        className={contentClassName}
        style={{
          overflow: 'hidden',
          height: isActive ? 'auto' : '0px',
        }}
      >
        {content}
      </div>
    </div>
  )
}
